// Liste des pays prioritaires pour Swiftlink-Africa.
// Format ISO-3166 alpha-2 + libellé en français + indicatif téléphonique.
// L'indicatif n'est pas obligatoire mais sert d'aide pour pré-formater le téléphone.

export const COUNTRIES = [
  // Corridors actifs en tête
  { code: "TG", label: "Togo", dial: "+228", emoji: "🇹🇬" },
  { code: "GA", label: "Gabon", dial: "+241", emoji: "🇬🇦" },
  { code: "FR", label: "France", dial: "+33", emoji: "🇫🇷" },
  { code: "RW", label: "Rwanda", dial: "+250", emoji: "🇷🇼" },
  // Afrique de l'Ouest et Centrale
  { code: "BJ", label: "Bénin", dial: "+229", emoji: "🇧🇯" },
  { code: "BF", label: "Burkina Faso", dial: "+226", emoji: "🇧🇫" },
  { code: "CI", label: "Côte d'Ivoire", dial: "+225", emoji: "🇨🇮" },
  { code: "CM", label: "Cameroun", dial: "+237", emoji: "🇨🇲" },
  { code: "CD", label: "RD Congo", dial: "+243", emoji: "🇨🇩" },
  { code: "CG", label: "Congo-Brazzaville", dial: "+242", emoji: "🇨🇬" },
  { code: "ML", label: "Mali", dial: "+223", emoji: "🇲🇱" },
  { code: "NE", label: "Niger", dial: "+227", emoji: "🇳🇪" },
  { code: "SN", label: "Sénégal", dial: "+221", emoji: "🇸🇳" },
  { code: "TD", label: "Tchad", dial: "+235", emoji: "🇹🇩" },
  { code: "GN", label: "Guinée", dial: "+224", emoji: "🇬🇳" },
  { code: "MA", label: "Maroc", dial: "+212", emoji: "🇲🇦" },
  { code: "DZ", label: "Algérie", dial: "+213", emoji: "🇩🇿" },
  { code: "TN", label: "Tunisie", dial: "+216", emoji: "🇹🇳" },
  // Afrique de l'Est
  { code: "KE", label: "Kenya", dial: "+254", emoji: "🇰🇪" },
  { code: "UG", label: "Ouganda", dial: "+256", emoji: "🇺🇬" },
  { code: "BI", label: "Burundi", dial: "+257", emoji: "🇧🇮" },
  { code: "TZ", label: "Tanzanie", dial: "+255", emoji: "🇹🇿" },
  // Europe (diaspora)
  { code: "BE", label: "Belgique", dial: "+32", emoji: "🇧🇪" },
  { code: "CH", label: "Suisse", dial: "+41", emoji: "🇨🇭" },
  { code: "DE", label: "Allemagne", dial: "+49", emoji: "🇩🇪" },
  { code: "IT", label: "Italie", dial: "+39", emoji: "🇮🇹" },
  { code: "ES", label: "Espagne", dial: "+34", emoji: "🇪🇸" },
  { code: "GB", label: "Royaume-Uni", dial: "+44", emoji: "🇬🇧" },
  // Amérique du Nord
  { code: "US", label: "États-Unis", dial: "+1", emoji: "🇺🇸" },
  { code: "CA", label: "Canada", dial: "+1", emoji: "🇨🇦" },
  // Autre
  { code: "OT", label: "Autre", dial: "", emoji: "🌍" },
];

export const COUNTRY_BY_CODE = Object.fromEntries(COUNTRIES.map((c) => [c.code, c]));
